/**
 * Haptics for components: the original `impact` / `selectionChanged` API (kept for existing call sites) plus
 * `notification` and the intent-based `haptic`. All of it delegates to `src/native/haptics.ts`, which owns
 * the plugin, the per-intent throttle and the creator's on/off setting. No-op on the web.
 *
 * Prefer `haptic(intent)` in new code: it says what happened ('toggle', 'commit', 'success'…), not how hard to
 * buzz. See docs/harness-v2/MOBILE.md for the vocabulary.
 */
import { haptic } from '@/native/haptics'

async function impact(style: 'light' | 'medium' | 'heavy' = 'light'): Promise<void> {
    haptic(style)
}

async function selectionChanged(): Promise<void> {
    haptic('selection')
}

async function notification(type: 'success' | 'warning' | 'error' = 'success'): Promise<void> {
    haptic(type)
}

export function useHaptics() {
    return { impact, selectionChanged, notification, haptic }
}
